// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaInputDateRange from './data'

export default function TysiaInputDateRangeFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaInputDateRange">
      <TysiaInputDateRange {...props}>
        {children}
      </TysiaInputDateRange>
    </Flow>
  )
}
